import opentype from 'opentype.js';

let graphic = document.querySelector('#display_container');
var resize = document.getElementById('resize');
var canvas = document.getElementById('opentype');
var ctx = canvas.getContext('2d');

let graphicWidth;
let graphicHeight;
graphicWidth = graphic.clientWidth;
graphicHeight = graphic.clientHeight;  

let selectOrUpload = "select";
let arrayGlyphs = [];
let arrayGlyphsCopy = [];
let arrayUnicode = [];
let arrayCommands = [];

let xPos, yPos;

// TITLE ANIM --------------------------------------------------------------
let title = document.querySelector('#title');
let title_letter = document.querySelectorAll('.title_letter');
title.addEventListener('mouseenter', event => { 
    randOrder();
}); 

title.addEventListener('mouseleave',event => {
    resetOrder();
});

if (window.matchMedia("(max-width: 900px)").matches) {
    let timer = 0;

    setInterval(()=>{
        timer++;
        if (timer === 500) {
            randOrder()
        }

        if(timer === 1000){
            resetOrder()
            timer = 0;
        }
    }, 1);
}

function randOrder() {
    title_letter.forEach(t_l => {
        let randInt = Math.floor(Math.random() * 5);
        t_l.style.order = randInt;
    }); 
}

function resetOrder() {
    title_letter.forEach(t_l => {
        let t_l_pos = t_l.dataset.pos; 
        t_l.style.order = t_l_pos;
    });
}

// RAND COLOR --------------------------------------------------------------
function randLightColor () {
    let randR = Math.floor(120 + Math.random() * 100);
    let randG = Math.floor(120 + Math.random() * 100);
    let randB = Math.floor(120 + Math.random() * 100);
    let randRGB = "rgb(" + randR + "," + randG + "," + randB + ")";
    return rgbToHex(randR, randG, randB);    
}

function randDarkColor () {
    let randR = Math.floor(50 + Math.random() * 100);
    let randG = Math.floor(50 + Math.random() * 100);
    let randB = Math.floor(50 + Math.random() * 100);
    let randRGB = "rgb(" + randR + "," + randG + "," + randB + ")";
    return rgbToHex(randR, randG, randB);    
}

function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}
  
function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

let darkColor = randDarkColor();
let lightColor = randLightColor();

document.body.style.backgroundColor = darkColor;
document.querySelector('#mobile').style.backgroundColor = lightColor;
document.querySelector('#mobile h1').style.color = darkColor;



// RAND FONT --------------------------------------------------------------
let array_font = [
    {
        value: "basically_a_mono_thin",
        name: "BasicallyAMono-Thin"
    },
    {
        value: "monor_bold",
        name: "Monor-Bold"
    },
    {
        value: "avara_black",
        name: "Avara-Black"
    },
    {
        value: "moche_bold",
        name: "Moche-Bold"
    },
    {
        value: "panchang_medium",
        name: "Panchang-Medium"
    },
    {
        value: "happy_times_ng_italic_master",
        name: "happy-times-NG_italic"
    },
    {
        value: "boxing_regular",
        name: "Boxing-Regular"
    }
]

let rand_font = array_font[Math.floor(Math.random() * array_font.length)] ;

// ORIGINAL VALUE --------------------------------------------------------------
let _units_per_em, _ascender, _descender;
// INPUT ------------------------------------------------------------------------
// let font_name = "Moche-Bold";
let font_name = rand_font.name;
let charset = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,;:.!?'"(){}[]<>+-*/\=@#%$€éèàçùêëïûâ&œ �`;
let text = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789,;:.!?'"(){}[]+-*/<>=%@#$€`;
// let font = `font/display/moche_bold.otf`;
let font = `font/display/` + rand_font.value + `.otf`;
// let text_color = "#ffffff";
// let background_color = "#282828";
let text_color = darkColor;
let background_color = lightColor;
// 144, 22, 243
// 161, 161, 161
let font_size = 80;
let letter_spacing = 1;
let line_height = 78;
let strenght = 0;
let remove = 0;
let x = 1;
let y = 1;
let line = 0;

// UPLOAD FONT
let buffer;
let fontArray = [];
let font_upload = document.querySelector('#font_upload');
font_upload.addEventListener("change", (event) => {
    let file = font_upload.files;
    fontArray.push(file[0]);
    font_name = file[0].name.slice(0, -4);
    fontArray.forEach((font_f, index) => {
        font = URL.createObjectURL(font_f);
        createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
    });
    deleteImage(0);
    selectOrUpload = "upload";
});


// SELECT FONT
let font_select = document.querySelector('#font_select');
font_select.addEventListener('change', ()=>{
    font = "font/display/" + font_select.value + ".otf";
    font_name = font_select.options[font_select.selectedIndex].dataset.name;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
    selectOrUpload = "select";
})

// CHANGE TEXT
let text_input = document.querySelector('#text');
text_input.addEventListener('input', ()=>{
    text = text_input.value;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// CHANGE TEXT COLOR
let text_color_input = document.querySelector('#text_color');
text_color_input.value = darkColor;
text_color_input.addEventListener('input', ()=>{
    text_color = text_color_input.value;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// CHANGE BACKGROUND COLOR
let background_color_input = document.querySelector('#background_color');
background_color_input.value = lightColor;
background_color_input.addEventListener('input', ()=>{
    background_color = background_color_input.value;
    document.querySelector('#resize').style.backgroundColor = background_color_input.value;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// FONT SIZE
let font_size_input = document.querySelector('#font_size');
let font_size_value = document.querySelector('#font_size_value');
font_size_input.addEventListener('input', ()=>{
    font_size = font_size_input.value;
    font_size_value.innerHTML = font_size;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// LETTER SPACING
let letter_spacing_input = document.querySelector('#letter_spacing');
let letter_spacing_value = document.querySelector('#letter_spacing_value');
letter_spacing_input.addEventListener('input', ()=>{
    letter_spacing = parseFloat(letter_spacing_input.value);
    if (letter_spacing === 1) {
        letter_spacing_value.innerHTML = "auto";
    }
    else{
        letter_spacing_value.innerHTML = letter_spacing;
    }
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// LINE HEIGHT
let line_height_input = document.querySelector('#line_height');
let line_height_value = document.querySelector('#line_height_value');
line_height_input.addEventListener('input', ()=>{
    line_height = parseFloat(line_height_input.value);
    line_height_value.innerHTML = line_height;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// CHANGE STRENGHT
let strenght_input = document.querySelector('#strenght');
let strenght_value = document.querySelector('#strenght_value');
strenght_input.addEventListener('input', ()=>{
    strenght = parseFloat(strenght_input.value);
    strenght_value.innerHTML = strenght;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// X AXIS
let x_axis = document.querySelector('#x_axis');
let x_value = document.querySelector('#x_value');
x_axis.addEventListener('input', ()=>{
    x = parseInt(x_axis.value);
    if ( x=== 1) {
        x_value.innerHTML = "on";
    }
    else{
        x_value.innerHTML = "off";
    }
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// Y AXIS
let y_input = document.querySelector('#y_axis');
let y_value = document.querySelector('#y_value');
y_input.addEventListener('input', ()=>{
    y = parseInt(y_input.value);
    if ( y=== 1) {
        y_value.innerHTML = "on";
    }
    else{
        y_value.innerHTML = "off";
    }
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// LINE
let line_input = document.querySelector('#line');
let line_value = document.querySelector('#line_value');
line_input.addEventListener('input', ()=>{
    line = parseInt(line_input.value);
    if (line === 1) {
        line_value.innerHTML = "on";
    }
    else{
        line_value.innerHTML = "off";
    }
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// REMOVE POINTS
let remove_input = document.querySelector('#remove');
let remove_value = document.querySelector('#remove_value');
remove_input.addEventListener('input', ()=>{
    remove = parseFloat(remove_input.value);
    remove_value.innerHTML = remove;
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
})

// RESIZE WINDOW ------------------------------------------------------------------------
window.addEventListener('resize', event =>{
    graphicWidth = graphic.clientWidth;
    graphicHeight = graphic.clientHeight; 
    if (selectOrUpload === "select") {
        createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
    } 
    else if(selectOrUpload === "upload"){
        let file = font_upload.files;
        fontArray.push(file[0]);
        fontArray.forEach((font, index) => {
            font = URL.createObjectURL(font);
            createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
         });
        deleteImage(0);    
    }
})

// RESIZE CANVAS ------------------------------------------------------------------------
function graphicsize() {
    graphicWidth = resize.clientWidth;
    graphicHeight = resize.clientHeight; 
    if (selectOrUpload === "select") {
        createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
    } 
    else if(selectOrUpload === "upload"){
        let file = font_upload.files;
        fontArray.push(file[0]);
        fontArray.forEach((font, index) => {
            font = URL.createObjectURL(font);
            createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
         });
        deleteImage(0);    
    }
}
   
new ResizeObserver(graphicsize).observe(resize)

// ANIMATION ------------------------------------------------------------------------
// setInterval(()=>{
//     if (strenght < 10) {
//         createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght+=.15, x, y, remove);
//     }
// }, 150)

let advance, descender;
// CREATE FONT -----------------------------------------------------------------------------------------------------
function createExportDisplay(font_file, text, textcolor, backgroundcolor, fontsize, letterspacing, lineheight, strenght, x_v, y_v, remove) {
        buffer = fetch(font_file).then(res => res.arrayBuffer());
        buffer.then(data => {
            createBoth();

            // CREATE FONT FOR EXPORT AND DISPLAY
            function createBoth() {
                // EXPORT FONT
                createFont(charset, 0, -260, 1000, 12.5);
                arrayGlyphsCopy = arrayGlyphs;
                // CLEAR CANVAS
                ctx.clearRect(0, 0, canvas.width, canvas.height);  
                //DISPLAY FONT   
                createFont(text, -70, 90, fontsize, 1);             
                arrayGlyphs = [];
            }

            // CREATE FONT 
            function createFont(txt, xNumber, yNumber, sizeNumber, posnegNumber){
                const font = opentype.parse(data);
                const dpi = window.devicePixelRatio;
                // CANVAS SIZES
                canvas.width = graphicWidth * dpi;
                canvas.height = graphicHeight * dpi;
                canvas.style.width = `${graphicWidth}px`;
                canvas.style.height = `${graphicHeight}px`;

                ctx.scale(dpi, dpi);
                ctx.fillStyle = backgroundcolor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // GET FONT VALUES
                _ascender = font.ascender;
                _descender = font.descender;
                _units_per_em = font.unitsPerEm;

                // CREATE A FONT OBJECT
                var glyph = font.stringToGlyphs(txt);
                let x = 0;
                let y = 0;
                let fontSize = sizeNumber;
                // var path = font.getPath(text, x, y, fontSize, {kerning: true, hinting: true});

                xPos = 75;
                // yPos = 125;
                yPos = 165;
                arrayGlyphs = [];

                // font.draw(ctx, text, xPos, yPos, fontSize)
                
                // CREATE EACH GLYPH
                for (let eachGlyph = 0; eachGlyph < glyph.length; eachGlyph++) {
                    // console.log(glyph[eachGlyph].name, glyph[eachGlyph].unicode);
                    let glyphPath;
                    // EXPORT POSITION
                    if (xNumber === 0) {
                        glyphPath = glyph[eachGlyph].getPath(xNumber, yNumber, fontSize);
                    }
                    // DISPLAY POSITION
                    else{
                        glyphPath = glyph[eachGlyph].getPath(xPos, yPos, fontSize);
                        // glyphPath.unicode = glyph[eachGlyph].unicode;
                    }

                    // POSITION OF DISPLAYED FONT 
                    if (xPos < graphicWidth - 180) {
                        xPos+= (fontSize * glyph[eachGlyph].advanceWidth / font.unitsPerEm) * letterspacing;
                    }
                    else{
                        xPos = 75;
                        yPos+= lineheight;
                    } 
                    
                    if(glyph[eachGlyph].unicode == 122 || glyph[eachGlyph].unicode == 90 || glyph[eachGlyph].unicode == 57 || glyph[eachGlyph].unicode == 93 ){
                        xPos = 75;
                        yPos+= lineheight + 50;
                    } 

                    console.log(yPos);
                    
                    glyphPath.fill = textcolor;

                    // MOVE POINTS FOR ALL GLYPH
                    for (let point = 0; point < glyphPath.commands.length; point++) {    
                        let posNeg = [Number(strenght * posnegNumber), Number(-strenght * posnegNumber)];
                        let randPosNeg = posNeg[Math.floor(Math.random() * posNeg.length)];
                        let randPosNeg2 = posNeg[Math.floor(Math.random() * posNeg.length)];
                        let randPosNeg3 = posNeg[Math.floor(Math.random() * posNeg.length)];
                        let randPosNeg4 = posNeg[Math.floor(Math.random() * posNeg.length)];
                        let randPosNeg5 = posNeg[Math.floor(Math.random() * posNeg.length)];
                        let randPosNeg6 = posNeg[Math.floor(Math.random() * posNeg.length)];

                        // REMOVE POINTS
                        for (let w = 0; w < Number(remove) * 10; w++) {
                            let randNumber = Math.floor(Math.random() * 100);
                            if (point === randNumber) {
                                glyphPath.commands[point].type = "";
                            }
                        }

                        if (line === 1) {
                            if (glyphPath.commands[point].type == "C" || glyphPath.commands[point].type == "Q"|| glyphPath.commands[point].type == "L") {
                                glyphPath.commands[point].type = "L"
                                let glyphPathX = glyphPath.commands[point].x;
                                let glyphPathY = glyphPath.commands[point].y;
                                glyphPath.commands[point].x = glyphPathX + (randPosNeg * x_v);
                                glyphPath.commands[point].y = Math.abs(glyphPathY + (randPosNeg2 * y_v));
                            }      
                            if (glyphPath.commands[point].type == "M") {
                                let glyphPathX = glyphPath.commands[point].x;
                                let glyphPathY = glyphPath.commands[point].y;
                                glyphPath.commands[point].x = glyphPathX + (randPosNeg * x_v);
                                glyphPath.commands[point].y = Math.abs(glyphPathY + (randPosNeg2 * y_v));
                            }                      
                        }                        
                        else {
                            // POSITION COMMAND
                            if (glyphPath.commands[point].type == "M") {
                                let glyphPathX = glyphPath.commands[point].x;
                                let glyphPathY = glyphPath.commands[point].y;
                                glyphPath.commands[point].x = glyphPathX + (randPosNeg * x_v);
                                glyphPath.commands[point].y = Math.abs(glyphPathY + (randPosNeg2 * y_v));
                            }
                            // LINE COMMAND 
                            else if (glyphPath.commands[point].type == "L") {
                                let glyphPathX = glyphPath.commands[point].x;
                                let glyphPathY = glyphPath.commands[point].y;
                                glyphPath.commands[point].x = glyphPathX + (randPosNeg * x_v);
                                glyphPath.commands[point].y = Math.abs(glyphPathY + (randPosNeg2 * y_v));
                            }
                            // CURVE COMMAND 
                            else if (glyphPath.commands[point].type == "C") {
                                let glyphPathX = glyphPath.commands[point].x;
                                let glyphPathY = glyphPath.commands[point].y;
                                let glyphPathX1 = glyphPath.commands[point].x1;
                                let glyphPathY1 = glyphPath.commands[point].y1;
                                let glyphPathX2 = glyphPath.commands[point].x2;
                                let glyphPathY2 = glyphPath.commands[point].y2;
                                glyphPath.commands[point].x = glyphPathX + (randPosNeg * x_v);
                                glyphPath.commands[point].y = Math.abs(glyphPathY + (randPosNeg2 * y_v));
                                glyphPath.commands[point].x1 = glyphPathX1 + (randPosNeg3 * x_v);
                                glyphPath.commands[point].y1 = Math.abs(glyphPathY1 + (randPosNeg4 * y_v));
                                glyphPath.commands[point].x2 = glyphPathX2 + (randPosNeg5 * x_v);
                                glyphPath.commands[point].y2 = Math.abs(glyphPathY2 + (randPosNeg6 * y_v));
                            }
                            // QUATERNION COMMAND 
                            else if (glyphPath.commands[point].type == "Q") {
                                let glyphPathX = glyphPath.commands[point].x;
                                let glyphPathY = glyphPath.commands[point].y;
                                let glyphPathX2 = glyphPath.commands[point].x2;
                                let glyphPathY2 = glyphPath.commands[point].y2;
                                glyphPath.commands[point].x = glyphPathX + (randPosNeg * x_v);
                                glyphPath.commands[point].y = Math.abs(glyphPathY + (randPosNeg2 * y_v));
                                glyphPath.commands[point].x2 = glyphPathX2 + (randPosNeg3 * y_v);
                                glyphPath.commands[point].y2 = Math.abs(glyphPathY2 + (randPosNeg4 * y_v));
                            }
                        }                        
                    }

                    // SAVE ALL GLYPH TO EXPORT
                    if (xNumber === 0) {
                        glyph[eachGlyph].path.commands = glyphPath.commands;
                    }
                    arrayGlyphs.push(glyph[eachGlyph]);                    
                    
                    // DISPLAY ALL GLYPHS
                    glyphPath.draw(ctx);
                }

            }
        })

}

// DELETE ADDED FONT
function deleteImage(index) {
    fontArray.splice(index, 1);
    createExportDisplay(font, text, text_color, background_color, font_size, letter_spacing, line_height, strenght, x, y, remove);
}

// DOWLOAD FONT
let download_font = document.querySelector('#download_font');
download_font.addEventListener('click', event =>{
    let file_name = window.prompt('Font name:', font_name);
    if (file_name === null) {
    
    }else{
        const newFont = new opentype.Font({
            familyName: file_name,
            styleName: 'distorted',
            unitsPerEm: _units_per_em,
            ascender: _ascender,
            descender: _descender,
            glyphs: arrayGlyphsCopy
        });
        newFont.download();   
    };
})

// DOWNLOAD CANVAS ----------------------------------------------------------------------
let download_canvas = document.querySelector('#download_canvas');
download_canvas.addEventListener('click', event =>{
  let file_name = window.prompt("File name :");
  if (file_name === null) {
    
  }else{
    var downloadImage = canvas.toDataURL();
    var tmpLink = document.createElement("a");
    tmpLink.download = file_name + ".png"; 
    tmpLink.href = downloadImage;
    
    document.body.appendChild(tmpLink);
    tmpLink.click();
    document.body.removeChild(tmpLink);
  }
})



// Cervel conseil
// ZES IBM
// formation de 57 jours en ile de france
// matinale tous les mardi et jeudi
// matinale de recrutement.
